import { useDispatch, useSelector } from "react-redux";
import PlusIcon from "../../Assets/PlusIcon/Add.svg";
import { Link } from "react-router-dom";
import ArrowLeft from '../../Assets/Arrow left.svg';
import ModalContainer from '../../Components/ModalContainer/ModalContainer';
import SelectModalType from "./Modal/SelectModalType";
import { fetchSizeCharts, setModal } from "../../Features/inventoryManagementSlice";
import SizeChartsList from "./Components/SizeChartsList";
import { useEffect } from "react";
import DeleteModal from "./Modal/DeleteModal";
import SizeChartDetails from "./Modal/SizeChartModal/SizeChartDetails";
import Loading from "../../Components/Loading/Loading";
import Error from "../../Components/Error/Error";

function SizeCharts() {
    const dispatch = useDispatch();

    const { activeModal, displayModal} = useSelector((state) => state.inventoryManagement.modal);
    const { sizeCharts, loading } = useSelector((state) => state.inventoryManagement.sizeCharts);

    const handleAddSizeChart = () => {
        dispatch(setModal('select-size-chart-type'));
    }

    useEffect(() => {
        dispatch(fetchSizeCharts());
        // eslint-disable-next-line
    }, []);

    if (loading === "loading") {
        return <Loading />;
    }

    if (loading === "failed") {
        return <Error />;
    }

    return (
        <div className="size-full overflow-y-scroll pb-28 outline-none">
            <div className="select-none flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to='..' className="p-[10px] flex items-center justify-center">
                        <img className='size-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-bold leading-8 text-[24px]">Size Charts</h1>
                </div>

                {
                    sizeCharts.length !== 0 && 
                    <button onClick={handleAddSizeChart} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>
                        <div className="size-6 flex items-center justify-center">
                            <img src={PlusIcon} alt="" />
                        </div>

                        Add Size Chart
                    </button>
                }
            </div>

            <div className='flex items-center justify-between gap-3 mt-4 mx-5'>
                {
                    sizeCharts.length === 0 && 
                    <div className="mx-auto mt-20 flex flex-col items-center gap-6 w-3/5">
                        <div className="flex flex-col gap-2 text-[#666666] items-center">
                            <h1 className='font-semibold text-[18px] leading-7'>Size charts not added yet</h1>

                            <p className='text-center font-medium text-[16px] leading-7'>It seems you haven't set up any size charts yet. Add a size chart to help customers choose the right size</p>
                        </div>

                        <button onClick={handleAddSizeChart} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>
                            <div className="size-6 flex items-center justify-center">
                                <img src={PlusIcon} alt="" />
                            </div>

                            Add Size Chart
                        </button>
                    </div>
                }

                {
                    sizeCharts.length > 0 && 
                    <SizeChartsList />
                }
            </div>

            {
                displayModal && 
                <ModalContainer>
                    {activeModal === 'select-size-chart-type' && <SelectModalType />}

                    {activeModal === 'delete-size-chart' && <DeleteModal />}

                    {activeModal === 'view-size-chart' && <SizeChartDetails />}
                </ModalContainer>
            }
        </div>
    );
}

export default SizeCharts;
